<template>
  <div id="pageViewProduto">
    <v-container grid-list-x2 fluid>
      <v-layout row wrap justify-center>
        <v-flex lg8 sm12 xs12>
          <v-card>
            <v-toolbar color="pink" dark flat dense cad>
              <v-toolbar-title class="subheading">Visualizar produto</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="">
              <produto-form></produto-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import ProdutoForm from "@/components/produto/view/formViewProduto"
export default {
  components: {
    ProdutoForm
  },
  data: () => ({
    id: null
  }),
  created() {
    if (this.$route && this.$route.params) {
      this.id = this.$route.params.id
    }
  }
}
</script>
